<template>
  <div class="table-page-search-wrapper">
    <a-form :layout="layout">
      <a-row :gutter="gutter">
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="应聘岗位">
            <a-select v-model="searchModel.departmentJob" :allowClear="true" placeholder="请选择应聘岗位">
              <a-select-option v-for="(item, index) in jobList" :key="index" :value="item.code">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="在职状态">
            <a-select v-model="searchModel.workStatus" :allowClear="true" placeholder="请选择在职状态">
              <a-select-option v-for="(item, index) in workStatusList" :key="index" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="当前状态">
            <a-select v-model="searchModel.status" :allowClear="true" placeholder="请选择当前状态">
              <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="面试日期">
            <a-date-picker
              placeholder="请选择面试日期"
              v-model="searchModel.planInterviewTime"
            />
          </a-form-item>
        </a-col>
        <a-col :md="spanMd" :sm="24">
          <a-form-item label="姓名">
            <a-input placeholder="请输入姓名" :allowClear="true" autocomplete="off" v-model="searchModel.userName" />
          </a-form-item>
        </a-col>
        <a-col :md="4" :sm="24">
          <span class="table-page-search-submitButtons">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
          </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'applicantSearchForm',
  computed: {
    ...mapGetters(['jobList'])
  },
  data () {
    return {
      layout: 'inline',
      gutter: 20,
      spanMd: 6,
      spanSm: 24,
      showExpend: true,
      workStatusList: [
        { label: '待业', value: 1 },
        { label: '在职', value: 2 },
      ],
      statusList: [
        { label: '待面试', value: 0 },
        { label: '确认面试', value: 1 },
        { label: '面试通过', value: 2 },
        { label: '面试未通过', value: 3 },
        { label: '取消入职', value: 4 },
        { label: '已入职', value: 6 },
        { label: '取消面试', value: 7 },
      ],
      searchModel: {},
      advanced: false, // 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      const model = this.searchModel
      if (model.userName) {
        model.userName = model.userName.trim()
      }
      for (var key in model) {
        if (!model[key] && model[key] !== 0) {
          delete model[key]
        }
      }
      this.$emit('setSearchCondition', model)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel = {}

      this.$emit('clearSearch', this.searchModel)
    }
  }
}
</script>

<style scoped lang="less">
</style>